import e from "@dialpad/dialtone-tokens/layered/themes/tokens-peach-blossom-colors.css?inline";
//#region themes/peach-blossom.js
var t = {
	brand: {
		css: e,
		name: "peach-blossom"
	},
	material: { name: "iron" }
};
//#endregion
export { t as default };
